/**
 * #1331 Part 1c — the Email admin pages moved under "Communication" (they now
 * carry WhatsApp too). Old URLs live on in bookmarks, mails and docs; each one
 * redirects to its new home (see LegacyAdminRedirects.tsx).
 */
export const LEGACY_ADMIN_REDIRECTS: ReadonlyArray<{ from: string; to: string }> = [
  { from: '/admin/email-templates', to: '/admin/communication-templates' },
  { from: '/admin/email-suppressions', to: '/admin/communication-suppressions' },
  // #1331 Part 2c — campaigns carry WhatsApp too. #1695 then split them into
  // Automations and Broadcasts: both old campaign URLs land on Broadcasts,
  // and the editor moves an automation to /admin/communication-automations.
  { from: '/admin/email-campaigns', to: '/admin/communication-broadcasts' },
  { from: '/admin/communication-campaigns', to: '/admin/communication-broadcasts' },
]
